import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { check_authenticated, load_user } from '../../../redux/actions/auth';

const ProtectedRoute = ({ element, allowedRoles }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const usuario = useSelector(state => state.Auth.user);
    const hasToken = !!localStorage.getItem('access');
    // Con el usuario ya cargado la sesión está confirmada: no se vuelve a verificar al cambiar de página.
    const needsCheck = hasToken && !usuario;
    const [checking, setChecking] = useState(needsCheck);

    useEffect(() => {
        if (!needsCheck) {
            return;
        }
        Promise.all([dispatch(check_authenticated()), dispatch(load_user())])
            .finally(() => setChecking(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!hasToken) {
        return <Navigate to="/" replace state={{ from: location }} />;
    }

    if (checking) {
        return null;
    }

    if (!usuario) {
        return <Navigate to="/" replace state={{ from: location }} />;
    }

    if (allowedRoles && !allowedRoles.includes(usuario.tipo)) {
        return <Navigate to="/landing" replace />;
    }

    return element;
};

export default ProtectedRoute;
